import React from "react";
import rehypeSanitize from "rehype-sanitize";
import styled from "styled-components";
import { GlossyThemeProvider } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import MDEditor from "@uiw/react-md-editor";
import RadarlyCardsMdEditorStyle from "@radarly/components/cards/md-editor-style";
import { tr } from "@radarly/i18n";
import { DatavizText } from "@radarly/models/dataviz";

export interface SharedWidgetsTextProps {
  dataviz: DatavizText;
  height: number;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
  locale: Locale;
}

const Placeholder = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HEADER_HEIGHT = 57;

const SharedWidgetsText = ({
  dataviz,
  height,
  locale,
  isFullscreen,
}: SharedWidgetsTextProps) => {
  const fullscreenHeight = window.innerHeight - HEADER_HEIGHT;
  return dataviz.content ? (
    <GlossyThemeProvider name="tile">
      <RadarlyCardsMdEditorStyle />
      <MDEditor
        visiableDragbar={false}
        value={dataviz.content}
        height={isFullscreen ? fullscreenHeight : height}
        hideToolbar
        preview="preview"
        fullscreen={false}
        previewOptions={{
          linkTarget: "_blank",
          rehypePlugins: [[rehypeSanitize]],
        }}
      >
        <MDEditor.Markdown
          source={dataviz.content}
          rehypePlugins={[[rehypeSanitize]]}
        />
      </MDEditor>
    </GlossyThemeProvider>
  ) : (
    <Placeholder>{tr(locale, "TEXT_CARD_PLACEHOLDER")}</Placeholder>
  );
};

export default SharedWidgetsText;
